import React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

/**
 * Mobile bottom navigation for conversation view
 * Provides quick access to main sections on mobile devices
 */
const MobileNavigation = ({ 
  activeTab, 
  onTabChange, 
  careNoteCount = 0,
  hasNewMessages = false,
  styles 
}) => {
  const navItems = [
    {
      id: 'messages',
      label: 'Messages',
      icon: <ChatBubbleOutlineIcon />,
      badge: hasNewMessages ? 1 : 0,
      badgeColor: 'primary'
    },
    {
      id: 'info',
      label: 'Info',
      icon: <InfoOutlinedIcon />,
      badge: 0
    },
    {
      id: 'notes',
      label: 'Notes',
      icon: <AssignmentOutlinedIcon />,
      badge: careNoteCount,
      badgeColor: 'error'
    },
    {
      id: 'actions',
      label: 'Actions',
      icon: <MoreVertIcon />,
      badge: 0
    }
  ];

  return (
    <Box sx={styles.mobileNavigation}>
      {navItems.map((item) => (
        <Box
          key={item.id}
          onClick={() => onTabChange(item.id)}
          sx={{
            ...styles.mobileNavItem,
            ...(activeTab === item.id && styles.mobileNavItemActive)
          }}
        >
          <Badge
            badgeContent={item.badge}
            color={item.badgeColor || 'default'}
            sx={{
              '& .MuiBadge-badge': {
                right: -3,
                top: 3,
                padding: '0 4px',
                height: '16px',
                minWidth: '16px',
                fontSize: '10px'
              }
            }}
          >
            {React.cloneElement(item.icon, {
              sx: {
                fontSize: '22px',
                color: 'inherit'
              }
            })}
          </Badge>
          <Typography
            variant="caption"
            sx={{
              fontSize: '11px',
              fontWeight: activeTab === item.id ? 600 : 400,
              color: 'inherit',
              lineHeight: 1
            }}
          >
            {item.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default MobileNavigation;